import type { Template } from "@/types";

export const PO_06_H0_V6: Template[] = [
{
    id: "po-06-h0v6-01",
    name: "PO 01 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 78, y: 185, width: 304, height: 480, rotation: 0, imageRotation: 0 },
            { id: "2", x: 650, y: 130, width: 343, height: 591, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 185, width: 148, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 390, y: 430, width: 148, height: 235, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1001, y: 130, width: 175, height: 291, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1001, y: 430, width: 175, height: 291, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-02",
    name: "PO 02 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 64, y: 171, width: 152, height: 251, rotation: 0, imageRotation: 0 },
        { id: "2", x: 64, y: 430, width: 152, height: 251, rotation: 0, imageRotation: 0 },
        { id: "3", x: 224, y: 171, width: 323, height: 510, rotation: 0, imageRotation: 0 },
        { id: "4", x: 671, y: 171, width: 323, height: 510, rotation: 0, imageRotation: 0 },  
        { id: "5", x: 1002, y: 171, width: 152, height: 251, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1002, y: 430, width: 152, height: 251, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-03",
    name: "PO 03 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 58, y: 145, width: 327, height: 562, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 393, y: 145, width: 156, height: 277, rotation: 0, imageRotation: 0 },
        { id: "3", x: 393, y: 430, width: 156, height: 276, rotation: 0, imageRotation: 0 },
        { id: "4", x: 697, y: 197, width: 271, height: 451, rotation: 0, imageRotation: 0 },
        { id: "5", x: 976, y: 197, width: 136, height: 222, rotation: 0, imageRotation: 0 },
        { id: "6", x: 976, y: 427, width: 136, height: 221, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-04",
    name: "PO 04 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_04.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 63, y: 233, width: 237, height: 386, rotation: 0, imageRotation: 0 },
        { id: "2", x: 308, y: 233, width: 237, height: 386, rotation: 0, imageRotation: 0 },
        { id: "3", x: 671, y: 145, width: 356, height: 562, rotation: 0, imageRotation: 0 },
        { id: "4", x: 1035, y: 145, width: 120, height: 182, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1035, y: 335, width: 120, height: 182, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1035, y: 525, width: 120, height: 182, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-05",
    name: "PO 05 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 53, y: 227, width: 122, height: 195, rotation: 0, imageRotation: 0 },
        { id: "2", x: 53, y: 430, width: 122, height: 194, rotation: 0, imageRotation: 0 },
        { id: "3", x: 182, y: 227, width: 242, height: 397, rotation: 0, imageRotation: 0 },
        { id: "4", x: 431, y: 227, width: 122, height: 195, rotation: 0, imageRotation: 0 },
        { id: "5", x: 431, y: 430, width: 122, height: 194, rotation: 0, imageRotation: 0 },
        { id: "6", x: 609, y: 0, width: 609, height: 851, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-06",
    name: "PO 06 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_06.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 61, y: 137, width: 123, height: 188, rotation: 0, imageRotation: 0 },
        { id: "2", x: 61, y: 333, width: 123, height: 187, rotation: 0, imageRotation: 0 },
        { id: "3", x: 61, y: 528, width: 123, height: 187, rotation: 0, imageRotation: 0 },
        { id: "4", x: 192, y: 137, width: 366, height: 578, rotation: 0, imageRotation: 0 },
        { id: "5", x: 663, y: 228, width: 246, height: 396, rotation: 0, imageRotation: 0 },
        { id: "6", x: 917, y: 228, width: 245, height: 396, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-07",
    name: "PO 07 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 609, height: 851, rotation: 0, imageRotation: 0 },
        { id: "2", x: 654, y: 223, width: 255, height: 406, rotation: 0, imageRotation: 0 },
        { id: "3", x: 917, y: 223, width: 124, height: 199, rotation: 0, imageRotation: 0 },
        { id: "4", x: 917, y: 430, width: 124, height: 199, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1049, y: 223, width: 123, height: 199, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1049, y: 430, width: 123, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-08",
    name: "PO 08 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 151, width: 420, height: 550, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 429, y: 151, width: 176, height: 271, rotation: 0, imageRotation: 0 },
        { id: "3", x: 429, y: 430, width: 176, height: 271, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 151, width: 175, height: 271, rotation: 0, imageRotation: 0 },
        { id: "5", x: 613, y: 430, width: 175, height: 271, rotation: 0, imageRotation: 0 },
        { id: "6", x: 796, y: 150, width: 420, height: 550, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-09",
    name: "PO 09 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 271, width: 197, height: 309, rotation: 0, imageRotation: 0 },
        { id: "2", x: 205, y: 271, width: 196, height: 309, rotation: 0, imageRotation: 0 },
        { id: "3", x: 409, y: 271, width: 196, height: 309, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 271, width: 196, height: 309, rotation: 0, imageRotation: 0 },
        { id: "5", x: 817, y: 271, width: 196, height: 309, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1021, y: 271, width: 196, height: 309, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h0v6-10",
    name: "PO 10 - H0V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h0_v6_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 82, y: 290, width: 169, height: 272, rotation: 0, imageRotation: 0 },
        { id: "2", x: 259, y: 290, width: 169, height: 272, rotation: 0, imageRotation: 0 },
        { id: "3", x: 436, y: 290, width: 169, height: 272, rotation: 0, imageRotation: 0 },
        { id: "4", x: 613, y: 290, width: 169, height: 272, rotation: 0, imageRotation: 0 },
        { id: "5", x: 790, y: 290, width: 169, height: 272, rotation: 0, imageRotation: 0 },
        { id: "6", x: 967, y: 290, width: 168, height: 272, rotation: 0, imageRotation: 0 }
    ],
}
];